// studentapps/Footer.js
import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { CorporateFare as CorporateIcon } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © 2025 Zolang Nexora - Student Suite. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CorporateIcon sx={{ fontSize: 16, color: 'primary.main' }} />
            <Typography variant="body2" color="primary.main" sx={{ fontWeight: 600 }}>
              Powered by Zolang Nexora
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            v1.0.0
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;